import { css } from '@emotion/react';
import {
  type FC, useState,
} from 'react';
import { ButtonComponent } from '~/_shared/baseComponents/buttons/button/button.component';
import { CheckboxComponent } from '~/_shared/baseComponents/checkbox';
import { Stack } from '~/_shared/baseComponents/layout/Stack.componment';
import { setModalConfirmedToStorage } from '~/_shared/components/modal/confirmation/confirmationModal.helpers';
import { PermanentConfirmStrategy } from '~/_shared/components/modal/confirmation/useConfirmationModal';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';
import { useStorageService } from '~/_shared/utils/storageService';
import type { ModalProps } from '~/modal/modalType.enum';
import { TWO_FA_WITH_SSO_PERMANENT_CONFIRM_ID } from '~/store/userData/userData.sagas';

const contentStyle = css({ padding: 20 });

const textStyle = css({
  cursor: 'default',
  whiteSpace: 'pre-line',
});

const checkboxWrapperStyle = (theme: Theme) => css({
  color: theme.textColors.secondary,
  marginTop: 24,
});

type TwoFactorWithSsoModalProps = ModalProps;

export const TwoFactorWithSsoModalComponent: FC<TwoFactorWithSsoModalProps> = ({ isOpen, onClose }) => {
  const [t] = useTranslation();
  const storageService = useStorageService();
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const handleClose = () => {
    if (doNotShowAgain) {
      setModalConfirmedToStorage(storageService, {
        id: TWO_FA_WITH_SSO_PERMANENT_CONFIRM_ID,
        strategy: PermanentConfirmStrategy.Local,
      });
    }
    onClose();
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={handleClose}
      caption={t('2FA.ssoModal.title')}
      contentStyle={contentStyle}
      confirmButton={(
        <ButtonComponent
          text={t('Got it')}
          onClick={handleClose}
        />
      )}
    >
      <Stack
        css={textStyle}
        gap={16}
      >
        <span>{t('2FA.ssoModal.settingsInfo')}</span>
        <span>{t('2FA.ssoModal.useEmailPassword')}</span>
      </Stack>
      <div css={checkboxWrapperStyle}>
        <CheckboxComponent
          isChecked={doNotShowAgain}
          checkedSetter={() => setDoNotShowAgain(prev => !prev)}
          text={t('Do not show again')}
        />
      </div>
    </ModalComponent>
  );
};
